import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import RequireAuth from "../components/RequireAuth";

const API_BASE = "https://eluvent.com/api";

const CompetitiveHistoryContent = () => {
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API_BASE}/competitive/history`, { withCredentials: true })
      .then(res => setAttempts(res.data.attempts || []))
      .catch(() => setError("Could not load your competitive exam history."))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 40, fontFamily: "'Nunito', sans-serif" }}>
        Loading your past exams…
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 800, margin: "0 auto", padding: 20, fontFamily: "'Nunito', sans-serif" }}>
      <Link to="/" style={{ color: "#6366f1", fontWeight: 700, fontSize: 13 }}>
        ← Back to Home
      </Link>

      <h1 style={{ textAlign: "center", color: "#1e3a5f", margin: "16px 0" }}>
        🏆 Competitive Exam History
      </h1>

      {error && <p style={{ textAlign: "center", color: "#ef4444" }}>{error}</p>}

      {!error && attempts.length === 0 && (
        <p style={{ textAlign: "center", color: "#64748b" }}>
          No competitive exams attempted yet.
        </p>
      )}

      <div style={{ display: "grid", gap: 12 }}>
        {attempts.map(attempt => (
          <div
            key={attempt.id}
            style={{
              background: "white",
              borderRadius: 16,
              padding: 16,
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              border: "1px solid #e2e8f0"
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
              <div>
                <h3 style={{ margin: 0, fontSize: 18, color: "#1e293b" }}>
                  {attempt.exam_type.replace(/_/g, " ")}
                  {attempt.class_level ? ` • Class ${attempt.class_level}` : ""}
                </h3>
                <p style={{ margin: "4px 0 0", fontSize: 12, color: "#64748b" }}>
                  {attempt.created_at ? new Date(attempt.created_at).toLocaleDateString() : ""} •{" "}
                  {attempt.difficulty_mode || "normal"} mode
                </p>
              </div>
              <div style={{ textAlign: "right" }}>
                <p
                  style={{
                    fontSize: 24,
                    margin: 0,
                    fontWeight: 800,
                    color:
                      attempt.percentage >= 60
                        ? "#10b981"
                        : attempt.percentage >= 40
                        ? "#f59e0b"
                        : "#ef4444"
                  }}
                >
                  {attempt.score}/{attempt.total_marks}
                </p>
                <p style={{ margin: 0, fontSize: 12, color: "#64748b" }}>
                  {attempt.percentage}% • {Math.floor((attempt.time_taken_seconds || 0) / 60)} min
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function CompetitiveHistory() {
  return (
    <RequireAuth>
      <CompetitiveHistoryContent />
    </RequireAuth>
  );
}